(function ($) {
  'use strict';

  var $layout = null;
  var effectiveUid = 0;
  var viewerUid = 0;
  var topbarUnread = 0;

  function notifUrl(path) {
    return effectiveUid > 0 ? path + '?uid=' + effectiveUid : path;
  }

  // Sync the topbar dot only when the user is viewing their own notifications.
  function syncTopbarDot(count) {
    if (effectiveUid !== viewerUid) return;
    var $dot = $('.user-notif-dot');
    if (count <= 0) {
      $dot.remove();
    } else {
      var label = count + ' notificación' + (count !== 1 ? 'es' : '') + ' sin leer';
      if ($dot.length) {
        $dot.attr('title', label).data('unread', count);
      } else {
        $('.user-avatar-wrapper').append('<span class="user-notif-dot" data-unread="' + count + '" title="' + label + '"></span>');
      }
    }
  }

  function updateUnreadBadge(delta) {
    var $tab   = $layout.find('.nmail-tab[data-tab="notif"]');
    var $badge = $tab.find('.nmail-tab-badge');
    if (!$badge.length) return;
    var count = parseInt($badge.text(), 10) + delta;
    topbarUnread = Math.max(0, topbarUnread + delta);
    syncTopbarDot(topbarUnread);
    if (count <= 0) {
      $badge.replaceWith('<span class="nmail-tab-count">' + $layout.find('.nmail-row').length + '</span>');
      $layout.find('.nmail-tabs-info').remove();
    } else {
      $badge.text(count);
      $layout.find('.nmail-tabs-info').text(count + ' sin leer');
    }
  }

  function removeRow($row) {
    var detailId = $row.data('detail');
    $row.css({ transition: 'opacity 0.25s', opacity: 0 });
    setTimeout(function () {
      $row.remove();
      $('#' + detailId).remove();
      if (!$layout.find('#panel-notif .nmail-row').length) {
        $layout.find('#panel-notif').html(
          '<div class="nmail-empty"><i class="fas fa-bell-slash"></i><p>Sin notificaciones</p></div>'
        );
        $layout.find('#nmail-delete-all, #nmail-mark-all-read').remove();
        clearDetail();
      }
    }, 250);
  }

  function init() {
    $layout = $('.nmail-layout');
    if (!$layout.length) return;

    effectiveUid  = parseInt($layout.data('uid'), 10) || 0;
    viewerUid     = parseInt($layout.data('viewer-uid'), 10) || 0;
    topbarUnread  = parseInt($('.user-notif-dot').data('unread'), 10) || 0;

    // Tab switching
    $layout.on('click', '.nmail-tab', function () {
      var tab = $(this).data('tab');
      $layout.find('.nmail-tab').removeClass('active');
      $(this).addClass('active');
      $layout.find('.nmail-panel').removeClass('active');
      $layout.find('#panel-' + tab).addClass('active');
      clearDetail();
    });

    // Row click → show detail + mark as read
    $layout.on('click', '.nmail-row', function (e) {
      if ($(e.target).closest('.nmail-delete-btn').length) return;
      var $row     = $(this);
      var detailId = $row.data('detail');

      $layout.find('.nmail-row').removeClass('selected');
      $row.addClass('selected');

      $('#nmail-detail-empty').hide();
      $layout.find('.nmail-detail-pane').hide();
      $('#' + detailId).show();

      // Mark as read if unread
      if ($row.hasClass('unread') && detailId && detailId.indexOf('notif-') === 0) {
        var notifId = detailId.replace('notif-', '');
        var $detailPane = $('#' + detailId);

        $.post(notifUrl('/wheeler-notifications/mark-read/' + notifId))
          .done(function (data) {
            if (data && data.status === 'ok') {
              $row.removeClass('unread').find('.nmail-unread-dot').remove();
              $detailPane.find('.nmail-detail-unread-badge').remove();
              updateUnreadBadge(-1);
              if (!$layout.find('.nmail-row.unread').length) {
                $('#nmail-mark-all-read').hide();
                $layout.find('.nmail-tabs-info').remove();
              }
            }
          });
      }

      // Mobile: scroll to detail panel
      if ($(window).width() < 992) {
        var $detail = $layout.find('.nmail-detail');
        $('html, body').animate({ scrollTop: $detail.offset().top - 72 }, 280);
      }
    });

    // Eliminar notificación individual
    $layout.on('click', '.nmail-delete-btn', function (e) {
      e.stopPropagation();
      var notifId  = $(this).data('notif-id');
      var $row     = $(this).closest('.nmail-row');
      var wasUnread = $row.hasClass('unread');

      $.post(notifUrl('/wheeler-notifications/delete/' + notifId))
        .done(function (data) {
          if (data && data.status === 'ok') {
            if (wasUnread) updateUnreadBadge(-1);
            removeRow($row);
          }
        });
    });

    // Marcar todas como leídas
    $layout.on('click', '#nmail-mark-all-read', function () {
      $.post(notifUrl('/wheeler-notifications/mark-all-read'))
        .done(function (data) {
          if (data && data.status === 'ok') {
            $layout.find('.nmail-row.unread').removeClass('unread').find('.nmail-unread-dot').remove();
            $layout.find('.nmail-detail-unread-badge').remove();
            $layout.find('.nmail-tabs-info').remove();
            var $tab   = $layout.find('.nmail-tab[data-tab="notif"]');
            var $badge = $tab.find('.nmail-tab-badge');
            if ($badge.length) {
              $badge.replaceWith('<span class="nmail-tab-count">' + $layout.find('#panel-notif .nmail-row').length + '</span>');
            }
            $('#nmail-mark-all-read').hide();
            topbarUnread = 0;
            syncTopbarDot(0);
          }
        });
    });

    // Eliminar todas
    $layout.on('click', '#nmail-delete-all', function () {
      if (!window.confirm('¿Eliminar todas las notificaciones?')) return;
      $.post(notifUrl('/wheeler-notifications/delete-all'))
        .done(function (data) {
          if (data && data.status === 'ok') {
            $layout.find('#panel-notif').html(
              '<div class="nmail-empty"><i class="fas fa-bell-slash"></i><p>Sin notificaciones</p></div>'
            );
            $layout.find('#nmail-delete-all, #nmail-mark-all-read').remove();
            $layout.find('.nmail-tabs-info').remove();
            $layout.find('.nmail-tab[data-tab="notif"] .nmail-tab-badge').replaceWith('<span class="nmail-tab-count">0</span>');
            $layout.find('.nmail-detail-pane[id^="notif-"]').remove();
            clearDetail();
            topbarUnread = 0;
            syncTopbarDot(0);
          }
        });
    });

    // Back button (mobile toolbar)
    $layout.on('click', '.nmail-back-btn', function () {
      clearDetail();
    });
  }

  function clearDetail() {
    if (!$layout) return;
    $layout.find('.nmail-row').removeClass('selected');
    $layout.find('.nmail-detail-pane').hide();
    $('#nmail-detail-empty').show();
  }

  $(document).ready(function () {
    init();
  });

})(jQuery);
